import type React from 'react';
import './ValueWithoutComplexity.css';

export default function ValueWithoutComplexity(): React.JSX.Element {
  return (
    <section className="vwc" aria-labelledby="vwc-heading">
      <div className="vwc__inner">
        <p className="vwc__eyebrow">Value without complexity</p>
        <h2 id="vwc-heading" className="vwc__heading">
          A smarter way to participate in the energy transition
        </h2>
        <div className="vwc__body">
          <p>
            Our approach enables landowners to benefit from renewable energy development
            while maintaining flexibility and control.
          </p>
          <p>We handle development, approvals, and delivery – so you don't have to.</p>
          <p>
            Through disciplined site selection and structured agreements, Everfield Group develops a portfolio
            of strategically located energy assets designed to meet growing grid and digital demand.
          </p>
        </div>
      </div>
    </section>
  );
}
